export function formatUSD(cents) {
    const dollars = (Number(cents || 0) / 100).toFixed(2);
    return `$${dollars}`;
  }
  
/** "$2,600.00" — thousands separators, for the dashboard's lists and numbers. */
export function formatMoney(cents) {
  return (Number(cents || 0) / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}
